<nav class="navbar navbar-expand headerContainer">
    <a class="navbar-brand d-flex" routerLink="/dashboard">
      <img *ngIf="!logoData" src="../../../assets/images/5_image.jpg" style="width: 50px;
    padding: 0px 5px;">
      <img *ngIf="logoData" id="company-logo-picture" class="company-logo-picture-class"
      [src]="logo" alt="your image" id="" name="" />
      <div class="logoTxt">
          @switch(selectedApp){
                        @case ('contract') {
                           <strong >Contract AI</strong>
                             <span *ngIf="caption">{{caption}} <b class="version-2"></b></span>
                           
                        }
                        @case('rfpcontract'){
                          <strong>RFP</strong>
                           <span *ngIf="caption">{{caption}} <b class="version-2"></b></span>
                         
                        }@case('infosecurity'){
                          <strong>Information Security</strong>
                            <span *ngIf="caption">{{caption}} <b class="version-2"></b></span>
                        }@case('document'){
                          <strong>Document Analytics</strong>
                          <span *ngIf="caption">{{caption}} <b class="version-2"></b></span>
                        }@case('email'){
                          <strong>Email Analytics</strong>
                          <span *ngIf="caption">{{caption}} <b class="version-2"></b></span>
                        }
                         @case('emailAudit'){
                          <strong>Email Analytics</strong>
                            <span *ngIf="caption">{{caption}} <b class="version-2"></b></span>
                        }
                        @default{
                        
        <strong *ngIf="title">{{title}}</strong>
        <span *ngIf="!title">Canstring AI <b class="version-2"></b></span>
        <span *ngIf="caption">{{caption}} <b class="version-2"></b></span>
            
                        }
          }              
       
      </div>
    </a>
    <div class="collapse navbar-collapse" id="navbarScroll">
    <ul class="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll" style="--bs-scroll-height: 100px;margin-right: 15px;">
      <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"
        tooltip="Apps" [options]="myOptions">
        <!-- <i class="bi bi-menu-button-wide" tooltip="Apps" [options]="myOptions2"></i> -->
        <!-- <img src="../../../assets/icons/oui--apps.svg" alt=""> -->
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <path fill="currentColor"
            d="M2 4V2h2v2zm5 0V2h2v2zm5 0V2h2v2zM2 9V7h2v2zm5 0V7h2v2zm5 0V7h2v2zM2 14v-2h2v2zm5 0v-2h2v2zm5 0v-2h2v2z" />
        </svg> -->

        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 16 16">
          <g fill="currentColor">
            <rect width="4" height="4" x="1" y="1" rx="1" ry="1" />
            <rect width="4" height="4" x="1" y="6" rx="1" ry="1" />
            <rect width="4" height="4" x="1" y="11" rx="1" ry="1" />
            <rect width="4" height="4" x="6" y="11" rx="1" ry="1" />
            <rect width="4" height="4" x="6" y="6" rx="1" ry="1" />
            <rect width="4" height="4" x="11" y="6" rx="1" ry="1" />
            <rect width="4" height="4" x="11" y="11" rx="1" ry="1" />
            <rect width="4" height="4" x="6" y="1" rx="1" ry="1" />
            <rect width="4" height="4" x="11" y="1" rx="1" ry="1" />
          </g>
        </svg>

      </a>
      <ul class="dropdown-menu app-box">
        <div class="row">
          <div class="col">
            <div class="apps-header-text text-center d-flex justify-content-center">AI Analytics, Summarization, and Process Automation</div>
          </div>
        </div>
        <div class="row">
          <ng-container *ngFor="let apps of appsList;">
        
            <ng-container *ngIf="apps?.active">
                <div class="col-4 mb-3" > 
                  <div class="card" (click)="selectedApps(apps)">
                    <div class="tile-wrapper">
                      <div class="icon-wrapper"><i class="{{apps.icon}} apps-icon"></i></div>
                      <div class="p tile-name">{{apps.text}}</div>
                    </div>
                  </div>
               </div>
            </ng-container>
          
          </ng-container>
        </div>
        <!-- <div style="width:100%; height:1px; background:#c8c8c8; margin-bottom:15px;"></div> -->
         <div class="row">

          <div class="col-4 mb-3" *ngFor="let apps of appsListNormal;">
             <ng-container *ngIf="apps?.active">
              <div class="card" (click)="selectedApps(apps)">
                <div class="tile-wrapper">
                  <div class="icon-wrapper"><i class="{{apps.icon}} apps-icon"></i></div>
                  <div class="p tile-name">{{apps.text}}</div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ul>


  </ul>
  </div>
</nav>    